import React from 'react';
import { LeadForm } from './LeadForm';
export function FinalCTA() {
  return <section className="py-20 bg-brand-navy relative overflow-hidden" data-id="element-59">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-60">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[150%] bg-brand-navy-light rounded-full blur-3xl opacity-50 transform rotate-12" data-id="element-61"></div>
        <div className="absolute top-[20%] -right-[10%] w-[40%] h-[100%] bg-brand-red rounded-full blur-3xl opacity-10 transform -rotate-12" data-id="element-62"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-63">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-64">
          <div className="text-white text-center lg:text-left" data-id="element-65">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black mb-6 leading-tight" data-id="element-66">
              Ready to Ship Your Boat? Get a Free Quote Today.
            </h2>
            <p className="text-lg text-slate-300 mb-8 max-w-xl mx-auto lg:mx-0" data-id="element-67">
              Join thousands of satisfied boat owners who trust LynJones
              Logistics for safe, reliable, and affordable boat transport
              nationwide.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-6" data-id="element-68">
              <div className="flex items-center gap-3" data-id="element-69">
                <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center" data-id="element-70">
                  <span className="font-bold text-xl text-brand-red" data-id="element-71">1</span>
                </div>
                <div className="text-left" data-id="element-72">
                  <p className="font-bold" data-id="element-73">Request Quote</p>
                  <p className="text-sm text-slate-400" data-id="element-74">Fast & Free</p>
                </div>
              </div>
              <div className="hidden sm:block w-12 h-0.5 bg-white/20" data-id="element-75"></div>
              <div className="flex items-center gap-3" data-id="element-76">
                <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center" data-id="element-77">
                  <span className="font-bold text-xl text-brand-red" data-id="element-78">2</span>
                </div>
                <div className="text-left" data-id="element-79">
                  <p className="font-bold" data-id="element-80">Approve Price</p>
                  <p className="text-sm text-slate-400" data-id="element-81">No Upfront Fees</p>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full max-w-md mx-auto lg:max-w-none lg:ml-auto" data-id="element-82">
            <LeadForm title="Start Your Transport Quote" data-id="element-83" />
          </div>
        </div>
      </div>
    </section>;
}